import React from 'react'
import people from "../../../../assets/img/dashboard/people.svg"
import reserve from "../../../../assets/img/dashboard/reserve.svg"
import heart from "../../../../assets/img/dashboard/heart-tick.svg"
import arrowDown from "../../../../assets/img/dashboard/arrow-down.svg"
import Button from '../../../shared/Button'
import PersianNumber from '../../../shared/PersianNumber'
const StaticHeaderBox = ({img,count,countTitle,info,percent,orange,purple}) => {

 console.log("percent",percent < 0)
    return (
      <div className='StaticHeaderBox' >
         <div className='d-flex-space'>
        <div className={`StaticHeaderBox-iconbox center ${orange ? "StaticHeaderBox-iconbox-orange" : purple ? "StaticHeaderBox-iconbox-purple" :"StaticHeaderBox-iconbox-green"}`}> <img src={img}/></div>
        <div className="gray-bg">
        ماهیانه
        </div>
         </div>
         <hr/>
         <div className='StaticHeaderBox-count'>
           
        <PersianNumber number={count} />
           <span> {countTitle}</span></div>
       <div className='d-flex-space'>
       <p>{info}</p>
     { percent !== undefined && <div className='flex items-center'>
           <img src={arrowDown}/>
           <div className={`${percent < 0 ? "text-[#ff2d2d]" : "text-[#009E35]"} font-[900] text-[14px]`}>{percent}%</div>
       </div>}
       </div>

          
      </div>
    )
  }
  
const StaticHeader = ({StatisticInfo}) => {
  return (
    <div className='StaticHeader'>
        <StaticHeaderBox img={people} count={StatisticInfo?.guests_count}  countTitle="مهمان" info='تعداد کل مهمان های شما در ماه' percent={StatisticInfo?.guest_growth}/>
        <StaticHeaderBox img={reserve} count={StatisticInfo?.count_nights} orange={true} countTitle=" شب اقامت" info='تعداد کل شب های رزرو شده در ماه' percent={StatisticInfo?.night_growth}/>
        <StaticHeaderBox img={heart} count={StatisticInfo?.count_wishlist} purple={true} countTitle=" پسند کرده" info='نفراتی که پسند کردن اقامتگاه های شما را' />
    </div>
  )
}

export default StaticHeader